import { render, staticRenderFns } from "./TechAccountView.vue?vue&type=template&id=3763fdff&scoped=true"
import script from "./TechAccountView.vue?vue&type=script&lang=js"
export * from "./TechAccountView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3763fdff",
  null
  
)

export default component.exports